'use client';

var translations = {
    'Job Title': 'Chức danh',
    Phone: 'Điện thoại',
    'Cover letter': 'Thư giới thiệu',
    Optional: 'Không bắt buộc',
    'Enter job title': 'Nhập chức danh',
    'Enter phone number': 'Nhập số điện thoại',
    'Enter cover letter': 'Nhập thư giới thiệu',
    'View sample': 'Xem mẫu thư giới thiệu',
    'Choose a profile to apply': 'Chọn hồ sơ ứng tuyển',
    'Employers prefer to receive your resume in': 'Nhà tuyển dụng ưu tiên hồ sơ ứng tuyển viết bằng',
    'Allow Employers to search': 'Cho phép Nhà tuyển dụng tìm kiếm',
    'VietnamWorks Profile': 'Hồ Sơ VietnamWorks',
    'Create attracted CV with WowCV': 'Tạo hồ sơ ấn tượng với WowCV',
    'This field is required.': 'Vui lòng nhập thông tin.',
    'Please do not enter numbers or special characters.': 'Vui lòng không nhập số hoặc kí tự đặc biệt.',
    'Please do not enter phone number or email.': 'Vui lòng không nhập số điện thoại hoặc email',
    'Please do not enter special characters.': 'Vui lòng không nhập kí tự đặc biệt.',
    'This is not a valid email address.': 'Địa chỉ email không hợp lệ.',
    'This is not a valid URL.': 'Đường dẫn không hợp lệ.',
    'The phone number format is invalid.': 'Số điện thoại của bạn không hợp lệ.',
    '/success-apply': '/ung-tuyen-thanh-cong',
    'Application confirmation': 'Xác nhận ứng tuyển',
    'Your current job level': 'Cấp bậc hiện tại của bạn',
    'is not matching to this job requirement': 'chưa phù hợp với yêu cầu công việc này',
    'Do you want to continue to apply?': 'Bạn có muốn tiếp tục nộp đơn?',
    'I agree to the': 'Tôi đồng ý với',
    'Privacy Policies': 'Quy định bảo mật',
    'Privacy Policy': 'Quy định bảo mật',
    'of this employer.': 'của nhà tuyển dụng này.',
    'of these Employers.': 'của các nhà tuyển dụng này.',
    'Please tick the checkbox if you want to proceed.': 'Vui lòng đánh dấu vào hộp chọn để tiếp tục nộp đơn.',
    'employer-privacy-policy': 'quy-dinh-bao-mat-nha-tuyen-dung'
};

export { translations as default };
//# sourceMappingURL=translations.js.map
